















import { Component, Vue } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import Brewery from '@/models/brewery'

@Component
export default class Home extends Vue {

    @Action fetchBreweries: any
    @State breweries?: Brewery[]

    async mounted() {
        await this.fetchBreweries()
    }
}
